<template>
  <div>
    <v-dialog
      width="800"
      fullscreen
      hide-overlay
      scrollable
      transition="dialog-bottom-transition"
      style="height: 100vh"
      v-model="showEditorDialog"
      :persistent="true"
    >
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on" elevation="0">
          Edit Content
          <v-icon small right>mdi-fullscreen</v-icon>
        </v-btn>
      </template>
      <v-app-bar color="primary" dark dense fixed elevation="0">
        <v-btn icon dark @click="showEditorDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Edit Content</v-toolbar-title>
      </v-app-bar>
      <v-card height="100%" style="overflow-y: auto; display: flex; align-items: center;">
        <div style="width: 800px">
          <PostEditor :content="content" @input="$emit('input', $event)"></PostEditor>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PostEditor from "./PostEditor";
export default {
  props: ["content"],
  components: { PostEditor },
  data() {
    return {
      showEditorDialog: false
    };
  }
};
</script>